<template>
    <div class="container">
         <img src="https://xperienceeducation-assets.s3.amazonaws.com/home/deep-header.png" alt="Header Image">
            <div class="header-image-overlay">
                Students Thrive When Learning is Personalized
            </div>
    </div>
</template>

<script>
export default {
    "name": "home-section-1",
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>

@import '@/styles/shared.scss';

.container{
    position: relative;
    text-align: center;
    color: white;
    background-color: #662d91;
    height: 200px;
    margin-bottom: 100px;

    @media(min-width: $bp-tablet-portrait){
        height: 100%;
    }


    img{
        display:none;

        @media(min-width: $bp-tablet-portrait){
            display: block;
            width: 100%;
            border-top: 3px solid black;
            border-bottom: 3px solid black;
        }
    }
}

.header-image-overlay{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-transform: uppercase;
    font-weight: 900;
    font-size: 1rem;
    width: 100%;

    @media(min-width: $bp-tablet-portrait){
        font-size: 1.5rem;
        width: 30%;
    }

    @media(min-width: $bp-laptop){
        font-size: 2rem;
        width: 30%;
    }


}

</style>